import { render, staticRenderFns } from "./exhibition.vue?vue&type=template&id=0f4ffa42&scoped=true"
import script from "./exhibition.vue?vue&type=script&lang=js"
export * from "./exhibition.vue?vue&type=script&lang=js"
import style0 from "./exhibition.vue?vue&type=style&index=0&id=0f4ffa42&prod&lang=scss"
import style1 from "./exhibition.vue?vue&type=style&index=1&id=0f4ffa42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4ffa42",
  null
  
)

export default component.exports